import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=09aea133&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=09aea133&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aea133",
  null
  
)

export default component.exports